const OFFSET_SCROLL = 220;

export default OFFSET_SCROLL;
